import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'administrators',
    collectionActionName: 'ADMINISTRATORS',
    itemActionName: 'ADMINISTRATOR',
});
